module.exports = __webpack_public_path__ + "83b27a79e6e1de8c31522562ab770cce.jpg";